let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lq9Le")).then(() => parcelRequire('baJ3W'));